module.exports = __webpack_public_path__ + "img/internal-api-hub.0d0af860.svg";